import React from "react";

const ImgHook = (props) => {
    return(
        <img width={props.width} height={props.height} src={props.imgUrl}/>
    );
}
export default ImgHook